import React from 'react'
import { Content, DefaultPage } from '@shared/layout/DefaultPage'
import Step1Image from '@images/InstallationGuide/step1.png'
import Step2Image from '@images/InstallationGuide/step2.png'
import Step3Image from '@images/InstallationGuide/step3.png'
import { BackArrowHeader } from '@widgets/BackArrowHeader'
import { Heading } from '@ui/Heading'
import { useIonRouter, UseIonRouterResult } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'

export const IosPwaInstallationGuide = () => {
	const nav: UseIonRouterResult = useIonRouter()
	const goBack = () => {
		if (nav.canGoBack()) {
			nav.goBack()
		} else {
			nav.push(ROUTES.overall.main)
		}
	}

	return (
		<DefaultPage>
			<Content>
				<BackArrowHeader style={{ alignItems: 'start' }} goBackFunction={goBack}>
					<Heading>Как установить приложение на iOS-устройство?</Heading>
				</BackArrowHeader>

				<div className='mb-8 mt-8'>
					<div className='flex items-center mb-4'>
						<div className='w-8 h-8 flex-shrink-0 flex items-center justify-center bg-blue-500 text-white font-bold rounded-full mr-3'>
							1
						</div>
						<h2 className='text-lg'>
							Откройте наш сайт{' '}
							<span className={'text-blue-700 underline'}>tisit.club</span> и нажмите
							на кнопку "Поделиться"
						</h2>
					</div>
					<img
						src={Step1Image}
						alt='Нажать кнопку "Поделиться"'
						className='rounded-lg shadow-md'
					/>
				</div>

				<div className='mb-8'>
					<div className='flex items-center mb-4'>
						<div className='w-8 h-8 flex-shrink-0 flex items-center justify-center bg-blue-500 text-white font-bold rounded-full mr-3'>
							2
						</div>
						<h2 className='text-lg'>Нажмите на кнопку "На экран Домой"</h2>
					</div>
					<img
						src={Step2Image}
						alt='Нажать на кнопку "На экран Домой"'
						className='rounded-lg shadow-md'
					/>
				</div>

				<div className='mb-8'>
					<div className='flex items-center mb-4'>
						<div className='w-8 h-8 flex-shrink-0 flex items-center justify-center bg-blue-500 text-white font-bold rounded-full mr-3'>
							3
						</div>
						<h2 className='text-lg'>Нажмите "Добавить"</h2>
					</div>
					<img
						src={Step3Image}
						alt='Нажмите "Добавить"'
						className='rounded-lg shadow-md'
					/>
				</div>
			</Content>
		</DefaultPage>
	)
}
